import type { CheckoutConfig as CC } from '../generated/checkout.graphql';
import * as CheckoutAlert from './CheckoutAlert';
import * as CheckoutCheckboxConfig from './CheckoutCheckboxConfig';
import * as CheckoutFeatures from './CheckoutFeatures';
import { take } from '../util/takePayload';
import * as TrackingEntry from './TrackingEntry';

export type CheckoutConfig = {
  eventId?: number;
  paymentProcessor?: string;
  processorAccountId?: string;
  processorPublicKey?: string;
  donation?: boolean;
  accessCode?: boolean;
  discount?: boolean;
  published?: boolean;
  includeConvenienceFee?: boolean;
  includeTaxFee?: boolean;
  includeCcFee?: boolean;
  requirePhoneNumber?: boolean;
  hiveBrandId?: string;
  checkboxes?: CheckoutCheckboxConfig.CheckoutCheckboxConfig[];
  quickCheckoutTos?: CheckoutCheckboxConfig.CheckoutCheckboxConfig;
  alerts?: CheckoutAlert.CheckoutAlert[];
  tracking?: TrackingEntry.TrackingEntry[];
  features?: CheckoutFeatures.CheckoutFeatures;
};

export const fromGql = (config: CC): CheckoutConfig => ({
  ...(take<CheckoutConfig>(
    config,
    'paymentProcessor',
    'processorPublicKey',
    'processorAccountId',
    'donation',
    'accessCode',
    'discount',
    'published',
    'includeConvenienceFee',
    'includeTaxFee',
    'includeCcFee',
    'requirePhoneNumber',
    'hiveBrandId',
  ) as CheckoutConfig),
  eventId: Number(config.eventId),
  checkboxes: config.checkboxes?.map(CheckoutCheckboxConfig.fromGql),
  features: config.features ? CheckoutFeatures.fromGqlCollection(config.features) : {},
  quickCheckoutTos: config.quickCheckoutTos ? CheckoutCheckboxConfig.fromGql(config.quickCheckoutTos) : undefined,
  alerts: config.alerts?.map(CheckoutAlert.fromGql),
  tracking: TrackingEntry.fromGqlCollection(config.tracking),
});
